import React from 'react';
import { Tooltip, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { RootCause, RootCauseWrapper } from './styled';

const RootCauseTitle = ({ record }) => {
  const { alertId, areAllRCDimensionsAvailable, isDeletedMetric, rootCauseDisplay = '' } = record;
  const urlPrefix = window.conviva?.baseUrl;
  const alertPath = 'pre-app-diagnostics';

  const rootCause = rootCauseDisplay?.split(' and ').map((part, index) => {
    const match = part.match(/^(.+?)\s+\((.+)\)$/);
    let result: any = [];
    if (match) {
      result = [match[1], match[2]];
    } else {
      result = ['', ''];
    }

    return (
      <RootCause key={index}>
        <span>{result[1]}</span>
        <Tag key={index}>{result[0] || 'Unknown'}</Tag>
      </RootCause>
    );
  });

  if (!areAllRCDimensionsAvailable) {
    return (
      <Tooltip
        key={rootCauseDisplay}
        title="Diagnostics are currently not supported for root-cause based on Custom Dimensions."
      >
        <RootCauseWrapper $drilldown={false}>{rootCause}</RootCauseWrapper>
      </Tooltip>
    );
  }

  if (isDeletedMetric) {
    return (
      <Tooltip key={rootCauseDisplay} title="The metrics has been deleted.">
        <RootCauseWrapper $drilldown={false}>{rootCause}</RootCauseWrapper>
      </Tooltip>
    );
  }

  const openInNewTab = (e) => {
    e.preventDefault();
    window.open(
      `${urlPrefix}/dashboard/ai-alerts/${alertPath}/${alertId}/`,
      '_blank',
      'noopener,noreferrer',
    ); // Open route in a new tab
  };

  return (
    <Link
      style={{ color: '#1556FF', fontWeight: 500 }}
      to={`${urlPrefix}/dashboard/ai-alerts/${alertPath}/${alertId}/`}
      onClick={openInNewTab}
    >
      <RootCauseWrapper $drilldown={true}>{rootCause}</RootCauseWrapper>
    </Link>
  );
};

export default RootCauseTitle;
